const REGION_PATHS = {
  iSpace: "M1076 325.5V583H1439.5V0H0V102H86.5L169 109.5L241 135L308.5 176.5L346 215L370 249L489 237L592.5 217L745 174.5H907.5L1099.5 170.5L1222.5 179L1301 199.5L1312 247.5L1315.5 269.5L1310.5 286.5L1300.5 294.5L1289.5 308.5L1272 331.5L1168.5 327L1076 325.5Z",
  sun: "M84.5 104H0V583H392L409.5 528.5L422.447 462V391L409.5 324.5L377.5 264L342.579 215.105L306.5 177.5L240.5 137.5L167 111.5L84.5 104Z",
  magnetosphere: "M696 287L744.5 287.5L847.5 302.5L918.5 319.5L926 321.5H941.5L1042 324L1074.5 325V583H393L410.5 528L423 462.5V391L415.5 352.5L548.5 330.5L558.5 327L612 302.5L640 296L679 287H696ZM781.644 387.087L759.583 396.347L739.061 413.323L721.617 441.104L717 469.398L719.565 497.179L731.878 522.901L748.296 541.422L773.435 557.37L811.913 562L849.878 549.653L873.479 532.162L887.33 509.012L894 482.774L891.435 445.734L878.608 421.555L861.165 402.521L835.513 387.087L803.704 384L781.644 387.087Z",
  earth: "M782.5 389.5L761 398.5L741 415L724 442L719.5 469.5L722 496.5L734 521.5L750 539.5L774.5 555L812 559.5L849 547.5L872 530.5L885.5 508L892 482.5L889.5 446.5L877 423L860 404.5L835 389.5L804 386.5L782.5 389.5Z",
  planets: [
    "M488 238.5L372 251L410.5 323.5L415.5 352L423.5 350.5L459.5 344.5L547.5 329.5L558 326L612.5 301.5L678.5 286H744.5L848 301.5L924.5 320H942.5L1063.5 323.5L1172.5 326L1264 330H1271L1300 294L1310 286L1314.5 269.5L1311.5 249L1300 200.5L1221.5 180.5L1099 172L932.5 176H744.5L593.5 219.5L488 238.5Z",
  ],
};

export function RegionHotzones({
  onRegionEnter,
  onRegionLeave,
  onRegionClick,
  onRegionMiddleClick,
}) {
  const handlersFor = (key) => ({
    onMouseEnter: () => onRegionEnter(key),
    onMouseLeave: () => onRegionLeave(),
    onClick: () => onRegionClick(key),
    onMouseDown: (event) => {
      if (event.button === 1) onRegionMiddleClick(key);
    },
  });

  return (
    <svg
      className="regionHotzones"
      viewBox="0 0 1440 583"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <g>
        <path
          id="I-Space"
          d={REGION_PATHS.iSpace}
          fillRule="evenodd"
          {...handlersFor('interplanetary')}
        />
        <path
          id="Sun"
          d={REGION_PATHS.sun}
          {...handlersFor('solar')}
        />
        <g id="Planets" {...handlersFor('planetaryMag')}>
          {REGION_PATHS.planets.map((d, i) => (
            <path key={i} d={d} />
          ))}
        </g>
        <path
          id="Magnetosphere"
          d={REGION_PATHS.magnetosphere}
          {...handlersFor('earthMag')}
        />
        <path
          id="Earth"
          d={REGION_PATHS.earth}
          {...handlersFor('earthAtmo')}
        />
      </g>
    </svg>
  );
}
